export enum ShowcaseType {
    BRANCH = 'Branch',
    ITEM = 'Item',
}
